import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/utils/index.css";
import { createHead } from '@vueuse/head'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 2. 引入组件样式
import 'vant/lib/index.css';
import {
    Button,
    NavBar,
    Icon,
    Image as VanImage,
    Step,
    Steps,
    Search,
    Uploader,
    Progress,
    Tab,
    Tabs,
    Toast,
    ActionSheet,
    Loading,
    Field,
    CellGroup,
    Overlay,
    Collapse,
    CollapseItem,
    Skeleton,
    SkeletonTitle,
    SkeletonImage,
    SkeletonAvatar,
    SkeletonParagraph,
    Popup
} from 'vant';

const app = createApp(App)
const head = createHead()
// 3. 注册你需要的组件
app.use(Button);
app.use(NavBar);
app.use(Icon);
app.use(VanImage);
app.use(Step);
app.use(Steps);
app.use(Search);
app.use(Uploader);
app.use(Progress);
app.use(Tab);
app.use(Tabs);
app.use(Toast);
app.use(Popup);
app.use(ActionSheet);
app.use(Loading);
app.use(Field);
app.use(CellGroup);
app.use(Overlay);
app.use(Collapse);
app.use(CollapseItem);
app.use(Skeleton);
app.use(SkeletonTitle);
app.use(SkeletonImage);
app.use(SkeletonAvatar);
app.use(SkeletonParagraph);
app.use(head)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
